'use strict'

jQuery(document).ready(function ($) { 
    if( $('.slick-buttons').length ) {
        $('.slick-buttons').slick();
    }
});